import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	sidebarLabel: {
		id: `eoc.team-dashboard.sidebar.label.no-translate`,
		defaultMessage: 'Operations Dashboard Navigation',
		description: 'Accessibility label of sidebar navigation',
	},
	description: {
		id: `eoc.team-dashboard.sidebar.description.no-translate`,
		defaultMessage: 'Operations',
		description: 'Description of project',
	},
	alerts: {
		id: `eoc.team-dashboard.sidebar.alerts.no-translate`,
		defaultMessage: 'Alerts',
		description: 'The label of menu item alerts',
	},
	reports: {
		id: `eoc.team-dashboard.sidebar.reports.no-translate`,
		defaultMessage: 'Reports',
		description: 'The label of menu item Reports',
	},
	onCall: {
		id: `eoc.team-dashboard.sidebar.on-call.no-translate`,
		defaultMessage: 'On-call',
		description: 'The label of menu item on-call',
	},
	integrations: {
		id: `eoc.team-dashboard.sidebar.integrations.no-translate`,
		defaultMessage: 'Integrations',
		description: 'The label of menu item integrations',
	},
	policies: {
		id: `eoc.team-dashboard.sidebar.policies.no-translate`,
		defaultMessage: 'Policies',
		description: 'The label of menu item policies',
	},
	automations: {
		id: `eoc.team-dashboard.sidebar.automations.no-translate`,
		defaultMessage: 'Automation',
		description: 'The label of menu item automations',
	},
	alertIssueSyncing: {
		id: `eoc.team-dashboard.sidebar.alertIssueSyncing.no-translate`,
		defaultMessage: 'Syncs',
		description: 'The label of menu item alertIssueSyncing',
	},
	settings: {
		id: `eoc.team-dashboard.sidebar.settings.no-translate`,
		defaultMessage: 'Member roles',
		description: 'The label of menu item ops settings',
	},
	heartbeats: {
		id: `eoc.team-dashboard.sidebar.heartbeats.no-translate`,
		defaultMessage: 'Heartbeats',
		description: 'The label of menu item called heartbeats',
	},
	maintenance: {
		id: `eoc.team-dashboard.sidebar.maintenance.no-translate`,
		defaultMessage: 'Maintenance',
		description: 'The label of menu item called maintenance',
	},
	giveFeedbackButton: {
		id: 'eoc.team-dashboard.sidebar.maintenance.no-translate',
		defaultMessage: 'Give feedback',
		description: 'Text of give feedback button',
	},
});

export default messages;
